import { authService } from '../services/authService';
import { router } from '../app';
import { Notification } from '../components/Notification.js';

export function LoginPage() {
    const page = document.createElement('div');
    page.className = 'page login-page container';

    const h2 = document.createElement('h2');
    h2.textContent = 'Iniciar Sesión';
    page.appendChild(h2);

    const notificationContainer = document.createElement('div');
    page.appendChild(notificationContainer);

    const form = document.createElement('form');
    form.id = 'loginForm';

    const usernameGroup = document.createElement('div');
    usernameGroup.className = 'form-group';
    const usernameLabel = document.createElement('label');
    usernameLabel.htmlFor = 'username';
    usernameLabel.textContent = 'Usuario:';
    const usernameInput = document.createElement('input');
    usernameInput.type = 'text';
    usernameInput.id = 'username';
    usernameInput.required = true;
    usernameGroup.appendChild(usernameLabel);
    usernameGroup.appendChild(usernameInput);
    form.appendChild(usernameGroup);

    const passwordGroup = document.createElement('div');
    passwordGroup.className = 'form-group';
    const passwordLabel = document.createElement('label');
    passwordLabel.htmlFor = 'password';
    passwordLabel.textContent = 'Contraseña:';
    const passwordInput = document.createElement('input');
    passwordInput.type = 'password';
    passwordInput.id = 'password';
    passwordInput.required = true;
    passwordGroup.appendChild(passwordLabel);
    passwordGroup.appendChild(passwordInput);
    form.appendChild(passwordGroup);

    const submitButton = document.createElement('button');
    submitButton.type = 'submit';
    submitButton.className = 'btn btn-primary btn-block';
    submitButton.textContent = 'Acceder';
    form.appendChild(submitButton);

    // 👇👇👇 NUEVO: BOTÓN DE INSTALAR APP 👇👇👇
    // Solo lo mostramos si NO está ya instalada (modo navegador)
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone;
    
    if (!isStandalone) {
        const installBtn = document.createElement('button');
        installBtn.type = 'button'; // Importante: tipo button para no enviar el formulario
        installBtn.className = 'btn btn-block'; // Usamos estilos base de botón
        // Estilos inline para diferenciarlo (Dorado oscuro / borde)
        installBtn.style.cssText = "margin-top: 15px; background: transparent; border: 2px solid #D4AF37; color: #D4AF37; font-weight: bold;";
        installBtn.innerHTML = '📲 Instalar App';

        installBtn.addEventListener('click', async () => {
            // A. Intento automático (Android/Chrome PC)
            if (window.deferredPrompt) {
                window.deferredPrompt.prompt();
                const { outcome } = await window.deferredPrompt.userChoice;
                console.log(`User response: ${outcome}`);
                if (outcome === 'accepted') {
                    window.deferredPrompt = null;
                }
            } 
            // B. Fallback Manual (iOS / Chrome si ya se ignoró antes)
            else {
                const isIos = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
                let msg = "Para instalar la App manualmente:\n\n";
                if (isIos) {
                    msg += "🍏 iOS: Presiona el botón 'Compartir' (cuadrado con flecha) y selecciona 'Agregar a Inicio'.";
                } else {
                    msg += "🤖 Android: Presiona el menú del navegador (3 puntos) y selecciona 'Instalar aplicación' o 'Agregar a pantalla principal'.";
                }
                alert(msg);
            }
        });

        form.appendChild(installBtn);
    }
    // 👆👆👆 FIN DEL NUEVO BOTÓN 👆👆👆

    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const username = usernameInput.value;
        const password = passwordInput.value;

        try {
            await authService.login(username, password);
            Notification(notificationContainer, 'Login exitoso, redirigiendo...', 'success');

            const user = authService.getCurrentUser();
            if (user) {
                switch (user.role) {
                    case 'admin':
                        router.navigate('/admin');
                        break;
                    case 'cashier':
                        router.navigate('/cashier');
                        break;
                    case 'payout_agent':
                        router.navigate('/payout');
                        break;
                    default:
                        router.navigate('/'); // Ruta por defecto si el rol no está mapeado
                }
            }
        } catch (error) {
            console.error('Error de login:', error);
            Notification(notificationContainer, error.message || 'Error de autenticación', 'error');
        }
    });

    page.appendChild(form);

    return page;
}